import CustomTable from '@components/custom-table/CustomTable';
import {
  CustomTableHeaderProps,
  CustomTableRowData
} from '@components/custom-table/types';

import { getIneligibleReasonLabel } from './constants';

import { IneligibleMember } from '../../types';

type IneligibleMemberTableProps = {
  members: IneligibleMember[];
  description: string;
};

const HEADERS: CustomTableHeaderProps[] = [
  { Header: 'Name', accessor: 'name', width: '50%' },
  { Header: 'Remarks', accessor: 'remarks', width: '50%' }
];

const IneligibleMemberTable = ({
  members,
  description
}: IneligibleMemberTableProps) => {
  const data: CustomTableRowData<number>[] = members.map((member) => ({
    id: member.group_member_id,
    name: <span className="text-sm text-cofeeNeutral10">{member.name}</span>,
    remarks: (
      <span className="text-sm text-cofeeNeutral10">
        {getIneligibleReasonLabel(member.reason)}
      </span>
    )
  }));

  return (
    <div>
      <p className="mb-3 text-sm text-cofeeNeutral7">{description}</p>
      <CustomTable<number> headers={HEADERS} data={data} className="!pb-0" />
    </div>
  );
};

export default IneligibleMemberTable;
